// extracted by mini-css-extract-plugin
export default {"phone":"index_phone__Ft1tQ","select":"index_select__aPKt6","icon":"index_icon__Y5IpZ","error":"index_error__VdYYm","borderColor":"index_borderColor__fargc"};